import React from "react";

export const PermissionData: any = React.createContext('default value');
export const HeaderHeading: any = React.createContext('default value');
export const BadgesCount: any = React.createContext('default value');
export const isLoaderLoading: any = React.createContext('default value');